export default __webpack_public_path__ + "static/media/egg-5.365923ce.png";